// backend/src/main.js

/**
 * Entry global del panel (Vite)
 * IMPORTANTE:
 * - Este import fuerza a Vite a generar /public/build/main.css
 * - Si no se importa CSS aquí, Vite NO genera main.css
 */
import "./styles.css";

import Alpine from "alpinejs";
import "htmx.org";

import { initTheme, __setTheme } from "./lib/theme";
import { initDropdownMobileFix } from "./lib/dropdown-mobile-fix";
import { initToasts } from "./lib/toast";
import { initConfirm } from "./lib/confirm";
import { initIcons } from "./lib/icons";

/** Exponer utilidades globales (útil para debug y helpers) */
window.Alpine = Alpine;
window.__setTheme = __setTheme;

initTheme();
initDropdownMobileFix();
initToasts();
initConfirm();
initIcons();

const appMain = () => document.getElementById("app-main");
const setHtmxLoading = (on) => {
  const el = appMain();
  if (!el) return;
  el.classList.toggle("is-htmx-loading", Boolean(on));
};

/**
 * Pages (por vista)
 * - Vite incluirá automáticamente los módulos que existan en /pages
 */
const pages = import.meta.glob("./pages/**/*.js");

// FIX: helper reutilizable (también para swaps de htmx)
async function initPageModule() {
  // FIX robusto:
  // - Preferimos <body data-page>
  // - fallback a <html data-page>
  // - fallback a cualquier nodo con [data-page] (por si un layout parcial/no-layout)
  const page =
    (document.body?.dataset?.page)
      ? document.body.dataset.page
      : (document.documentElement?.dataset?.page)
        ? document.documentElement.dataset.page
        : (document.querySelector('[data-page]')?.dataset?.page || '');

  const key = page ? `./pages/${page}.js` : null;
  const businessKey = page && page.startsWith('business-')
    ? `./pages/business/${page.replace('business-', '')}.js`
    : null;

  try {
    const targetKey = (key && pages[key]) ? key : (businessKey && pages[businessKey]) ? businessKey : null;
    if (targetKey) {
      const mod = await pages[targetKey]();
      // soporte opcional: export default function init() {}
      if (typeof mod?.default === "function") mod.default();
    }
  } catch (e) {
    console.warn(`[pages] No se pudo cargar "${page}":`, e);
  }
}

(async () => {
  // Cargar módulo de página ANTES de iniciar Alpine
  await initPageModule();

  // Dar tiempo para que los event listeners de 'alpine:init' se registren
  await new Promise(resolve => setTimeout(resolve, 10));

  // Alpine al final (ya tienes todo registrado / listo)
  Alpine.start();

  /**
   * htmx: re-hidratar Alpine + icons + page init cuando se reemplaza contenido
   * (necesario para chips animados, filtros, etc. sin recargar)
   */
  document.body.addEventListener("htmx:afterSwap", async (evt) => {
    initIcons();

    // Re-init del módulo de página (si el swap reemplaza inputs, etc.)
    await initPageModule();

    // Alpine: inicializa el árbol recién insertado
    if (evt?.detail?.elt) Alpine.initTree(evt.detail.elt);
  });

  document.body.addEventListener("htmx:beforeRequest", () => {
    setHtmxLoading(true);
  });

  document.body.addEventListener("htmx:afterRequest", () => {
    setHtmxLoading(false);
  });

  document.body.addEventListener("htmx:responseError", () => {
    setHtmxLoading(false);
  });
})();
